import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { captureUtmParams } from "../utils/attribution";

export default function useUtmAttribution() {
  const { search } = useLocation();

  useEffect(() => {
    captureUtmParams();
  }, [search]);
}
